import Modal from "~/common/components/Modal";

import classes from "~/features/selectionAssistant/bearing/components/AbbreviationListModal/AbbreviationListModal.module.less";
import { useIsMinTabletSize } from "~/common/hooks/useMediaQuery";
import { openModal } from "~/common/utils/ModalService";
import { useTranslation } from "react-i18next";
import { LinkButton } from "~/common/components/Link";
import { Icon } from "~/common/components/icon/Icon";
import { IconType } from "~/common/components/icon/IconType";
import { type Attribute } from "~/features/selectionAssistant/bearing/components/AbbreviationListModal/constants";

interface Props {
  onClose: () => void;
  attributes: Attribute[];
}

export const AbbreviationListModal = (props: Props) => {
  const { t } = useTranslation();
  const isMinTabletSize = useIsMinTabletSize();
  return (
    <Modal onClose={props.onClose} title={t("page.sa.common.seeAbbreviations")}>
      <div className={classes.root}>
        <div className={classes.attributeList}>
          {props.attributes.map((attribute) => (
            <div>
              {attribute.symbol} - {attribute.name}
            </div>
          ))}
        </div>
      </div>
    </Modal>
  );
};

interface BtnProps {
  className?: string;

  attributes: Attribute[];
}
export const OpenAbbreviationsBtn = ({ className, attributes }: BtnProps) => {
  const { t } = useTranslation();

  const onClick = () =>
    openModal("abbreviation-list-modal", (close) => <AbbreviationListModal onClose={close} attributes={attributes} />);

  return (
    <LinkButton className={className} onClick={onClick} iconBefore={<Icon type={IconType.InfoCircleOutline} />}>
      {t("page.sa.common.seeAbbreviations")}
    </LinkButton>
  );
};
